import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dirArrow-r",
  "use": "dirArrow-r-usage",
  "viewBox": "0 0 23 6.01",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 6.01\" id=\"dirArrow-r\"><title>dirArrow-r</title><path d=\"M0 2.01h17v-2l6 3-6 3v-2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dirArrow-r.svg
// module id = axVX
// module chunks = 6